import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { Observable } from 'rxjs/Observable';

import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AllAuthGuard implements CanActivate {
    constructor(private http:Http, private authService: AuthService, private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
        let hasRole = false;

        let token = localStorage.getItem("scnntttoken");
        let expires = new Date(localStorage.getItem("expires"));
        //console.log(expires); 

        let date =  new Date();
        //console.log(date);
        if (token == null || token == undefined || expires < date) {
            //this.authService.redirectUrl = state.url;
            this.authService.isLoggedIn = false;
            this.authService.menuItems = [];
            this.authService.dsRoutes = [];            
            //localStorage.removeItem('scnntttoken');
            //localStorage.removeItem('userInfo');
            localStorage.clear();
            hasRole = false;  
        }
        else {
            if (state.url != "/home" ) {                
                if (this.authService.dsRoutes == null || this.authService.dsRoutes == undefined) {
                    hasRole = false;
                }
                else {
                    //console.log(state.url);
                    for (let i = 0; i < this.authService.dsRoutes.length; i++) {
                        
                        if (state.url.startsWith("/" + this.authService.dsRoutes[i].RouterPath) && this.authService.dsRoutes[i].RouterPath.length >0) {
                            hasRole = true;
                            break;
                        }
                    }
                    //console.log(hasRole);
                    if(!hasRole){
                        hasRole = true;
                        this.router.navigate(['./tai-khoan']);
                    }
                }
            }
            else {                
                hasRole = true;
            }
        }

        if (!hasRole) {
            this.router.navigate(['./login']);
        }
        return hasRole;
        
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/services/all-auth.service.ts